var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { memo } from "react";
var SvgFileUpload = function SvgFileUpload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "file_upload"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.7526 15.125H14.2526V9.62498H17.9193L11.5026 3.20831L5.08594 9.62498H8.7526V15.125ZM5.08594 16.9583H17.9193V18.7916H5.08594V16.9583Z",
    fill: "currentColor"
  }))));
};
var Memo = /*#__PURE__*/memo(SvgFileUpload);
export { Memo as ReactComponent };
export default __webpack_public_path__ + "_/_/packages/moonlight/lib/assets/icons/file-upload.ac2cb749f5b04193960db7195751bb67.svg";